/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import { axiosFetch } from './axiosFetch';
import { urlModifier, getHeaders } from '../utils';
import API_CONSTANTS from '../constants/apiConstants';

export const getUserInfo = async () => {
  const apiPath = urlModifier(API_CONSTANTS.GET_USER_INFO);
  const reqOptions = {
    ...getHeaders()
  };

  // skip error handling through interceptor
  const errorHandlingProps = {
    skipError: true,
    codes: [403]
  };

  return axiosFetch(reqOptions, apiPath, {}, errorHandlingProps);
};

// Getting all users info
export const getAllUsersInfo = async (onlyEmailAndId = false) => {
  const apiPath = API_CONSTANTS.GET_ALL_USERS;
  const reqOptions = {
    ...getHeaders()
  };

  const response = await axiosFetch(reqOptions, apiPath, { onlyEmailAndId });
  return response && response.data;
};
